export const backToTop = (function ($) {

    const $button = $(".js-back-to-top");

    function init() {
        $button.on("click", function () {
            $("html,body").animate({
                scrollTop: 0,
            }, 0);
        });
    }

    return {
        init: init
    }

})(jQuery);
